import fetch from './fetch';

const queryChildByTargetId = (targetId) => {
    return fetch.get(`target/config/queryChildByTargetId/${targetId}`)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const save = (targetId, data) => {
    return fetch.post(`target/config/save/${targetId}`, data)
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}

const getLast = () => {
    return fetch.get('target/config/getLast')
    .then(res => {
        if (res.code === 200) {
            return res.payload.data;
        }
    })
}


export default {
    queryChildByTargetId,
    save,
    getLast
}